import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo-01.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f0f1be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lm-header" }
const _hoisted_2 = { class: "lm-logo-wrap" }
const _hoisted_3 = { class: "app-logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = ["aria-expanded"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "user-info"
}
const _hoisted_8 = { class: "user-info-main" }
const _hoisted_9 = { class: "fn" }
const _hoisted_10 = { class: "user-info-manage" }
const _hoisted_11 = {
  key: 0,
  class: "sub-nav-menu"
}
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.user.token)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "mobile-nav-toggle btn btn-link",
            type: "button",
            "aria-expanded": _ctx.isMobileNavOpen.toString(),
            "aria-label": "Toggle navigation",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args)))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["pi", _ctx.isMobileNavOpen ? 'pi-times' : 'pi-bars'])
            }, null, 2)
          ], 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("nav", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        class: _normalizeClass(["nav-menu", { 'is-open': _ctx.isMobileNavOpen }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            href: "#",
            class: _normalizeClass({ active: item.isActive }),
            key: item.title,
            onClick: ($event: any) => (_ctx.processMenuItemClick(item))
          }, _toDisplayString(_ctx.$t(item.title)), 11, _hoisted_6))
        }), 128))
      ], 2),
      (_ctx.user.token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.firstName + ' ' + _ctx.lastNameWithCompany), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn btn-link outline-none",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.processModifyAccount()))
                }, "Modify Account")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn btn-link outline-none",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, "Logout")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.user.token && _ctx.subMenuItems.items && _ctx.subMenuItems.items.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("nav", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMenuItems.items, (item) => {
              return (_openBlock(), _createElementBlock("a", {
                href: "#",
                class: _normalizeClass({ active: item.isActive }),
                key: item.title,
                onClick: ($event: any) => (_ctx.processMenuItemClick(item))
              }, _toDisplayString(_ctx.$t(item.title)), 11, _hoisted_12))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}